// Authentication constants
const USER_LOGIN = "USER_LOGIN";
const USER_LOGOUT = "USER_LOGOUT";

// Product Filter constants
const FOUR_STAR_AND_ABOVE = "FOUR_STAR_AND_ABOVE";
const THREE_STAR_AND_ABOVE = "THREE_STAR_AND_ABOVE";
const TWO_STAR_AND_ABOVE = "TWO_STAR_AND_ABOVE";
const ONE_STAR_AND_ABOVE = "ONE_STAR_AND_ABOVE";
const SORT_BY_PRICE = "SORT_BY_PRICE";
const SORT_BY_RATING = "SORT_BY_RATING";
const SORT_BY_PRICE_DESCENDING = "SORT_BY_PRICE_DESCENDING";
const SORT_BY_PRICE_ASCENDING = "SORT_BY_ASCENDING";
const SORT_BY_RATING_DESCENDING = "SORT_BY_RATING_DESCENDING";
const INCLUDE_OUT_OF_STOCK = "INCLUDE_OUT_OF_STOCK";
const INCLUDE_IN_STOCK = "INCLUDE_IN_STOCK";
const SELECT_ELECTRONICS_CATEGORY = "SELECT_ELECTRONICS_CATEGORY";
const UNSELECT_ELECTRONICS_CATEGORY = "UNSELECT_ELECTRONICS_CATEGORY";
const SELECT_FASHION_CATEGORY = "SELECT_FASHION_CATEGORY";
const UNSELECT_FASHION_CATEGORY = "UNSELECT_FASHION_CATEGORY";
const SELECT_SPORTS_CATEGORY = "SELECT_SPORTS_CATEGORY";
const UNSELECT_SPORTS_CATEGORY = "UNSELECT_SPORTS_CATEGORY";
const SELECT_ACCESSORIES_CATEGORY = "SELECT_ACCESSORIES_CATEGORY";
const UNSELECT_ACCESSORIES_CATEGORY = "UNSELECT_ACCESSORIES_CATEGORY";
const CLEAR_CATEGORY_FILTER = "CLEAR_CATEGORY_FILTER";
const CLEAR_SORT_BY_FILTER = "CLEAR_SORT_BY";
const CLEAR_INCLUDE_OUT_OF_STOCK_FILTER = "CLEAR_INCLUDE_OUT_OF_STOCK_FILTER";

// WishList and Cart constants
const SAVE_USER_WISHLIST = "GET_USER_WISHLIST";
const SAVE_USER_CART = "GET_USER_CART";
const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST";
const ADD_TO_CART = "ADD_TO_CART";
const REMOVE_FROM_CART = "REMOVE_FROM_CART";
const INCREASE_ITEM_QUANTITY = "increment";
const DECREASE_ITEM_QUANTITY = "decrement";

// Account level actions constants
const ADD_USER_ADDRESS = "ADD_USER_ADDRESS";
const UPDATE_USER_ADDRESS = "UPDATE_USER_ADDRESS";
const REMOVE_USER_ADDRESS = "REMOVE_USER_ADDRESS";

export { 
    USER_LOGIN, 
    USER_LOGOUT, 
    FOUR_STAR_AND_ABOVE, 
    THREE_STAR_AND_ABOVE, 
    TWO_STAR_AND_ABOVE,
    ONE_STAR_AND_ABOVE,
    SORT_BY_PRICE,
    SORT_BY_RATING,
    SORT_BY_PRICE_DESCENDING,
    SORT_BY_PRICE_ASCENDING,
    SORT_BY_RATING_DESCENDING,
    INCLUDE_OUT_OF_STOCK,
    INCLUDE_IN_STOCK,
    SELECT_ELECTRONICS_CATEGORY,
    UNSELECT_ELECTRONICS_CATEGORY,
    SELECT_FASHION_CATEGORY,
    UNSELECT_FASHION_CATEGORY,
    SELECT_SPORTS_CATEGORY,
    UNSELECT_SPORTS_CATEGORY,
    SELECT_ACCESSORIES_CATEGORY,
    UNSELECT_ACCESSORIES_CATEGORY,
    CLEAR_CATEGORY_FILTER,
    CLEAR_SORT_BY_FILTER,
    CLEAR_INCLUDE_OUT_OF_STOCK_FILTER,
    SAVE_USER_WISHLIST,
    SAVE_USER_CART,
    ADD_TO_WISHLIST,
    REMOVE_FROM_WISHLIST,
    ADD_TO_CART,
    REMOVE_FROM_CART,
    INCREASE_ITEM_QUANTITY,
    DECREASE_ITEM_QUANTITY,
    ADD_USER_ADDRESS,
    UPDATE_USER_ADDRESS,
    REMOVE_USER_ADDRESS
};
